import {
  productConversionSessionIdFormat,
  productConversionSessionLineIdFormat,
} from "@redotech/redo-fulfillment-id";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const createProductConversionSession = {
  name: "createProductConversionSession" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({ sessionId: productConversionSessionIdFormat.schema }),
};

const binAllocationSchema = z.object({
  binName: z.string(),
  quantity: z.number().int().positive(),
});

const targetLotSchema = z.object({
  lotNumber: z.string().min(1),
  expirationDate: z.date(),
});

export const addProductConversionLine = {
  name: "addProductConversionLine" as const,
  input: z.object({
    sessionId: productConversionSessionIdFormat.schema,
    sourceProductId: productIdFormat.schema,
    sourceBins: z.array(binAllocationSchema),
    targetProductId: productIdFormat.schema,
    targetBins: z.array(binAllocationSchema),
    targetLot: targetLotSchema.optional(),
  }),
  output: z.object({ lineId: productConversionSessionLineIdFormat.schema }),
};

export const generateProductConversionBarcodeLabels = {
  name: "generateProductConversionBarcodeLabels" as const,
  input: z.object({
    productIds: z.array(productIdFormat.schema),
    quantities: z.array(z.number().int().positive()),
    printerId: z.number().optional(),
  }),
  output: z.object({
    pdfBase64: z.string(),
    printJobId: z.number().optional(),
  }),
};
